import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'
import { Link } from 'react-router-dom'
import crumbContext from "contexts/crumbs"
import "./cpf.scss"
export default function Cpf() {
	const {setHeadband} = useContext(headbandContext)
	const {crumbs, setCrumbs} = useContext(crumbContext)
	useEffect(() => {
		setHeadband({
			title :  "Le compte personnel de formation",
			icon : "picto_compte_personnel_formation.svg",
			color : "bckRed"
		})
	}, [])
	return (
		<div id="cpf" className='page'>
			<img src="/cpf.png" alt="" />
			<Link to={"/accueil/drhf/fiche_contact"}
				className='cadreClique'
				onClick={() => {
                    setCrumbs([
						{
							page :'/accueil',
							title : "Accueil"
						},
						{
							page : "/accueil/drhf",
							title : "Ma DRHF"
						},
						{
							page : "/accueil/drhf/fiche_contact",
							title : "Fiche contact"
						},
					])                       
                }} 
			></Link>
		</div>
	)
}
